<template>
    <div>

        <GenericPostType
                :commentThreadId="activity.source.id"
                :uid="activity.uid"
                :createdOn="activity.createdOn"
        >
            <span slot="nextToName">
                added the trip <a @click="$router.push('/explore/trips/' + trip.id)"><b>{{trip.short_desc}}</b></a>
            </span>

            <div ref="myMap" style="padding:0px;width:100%; height:300px"></div>

        </GenericPostType>

    </div>
</template>


<script>
  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  import Vue from 'vue'
  import Moment from 'moment'
  import VueTimeago from 'vue-timeago'
  import Likes from '@/components/Likes/Likes'
  import GenericPostType from '@/components/Posts/Types/GenericPostType'
  import gmapsInit from '@/googleMapsConfig'

  export default {
    name:       'MediaPostType',
    components: {
      Likes,
      GenericPostType,
    },
    props:      [
      'activity',
    ],
    data ()
    {
      return {
        map:  null,
        trip: {},
      }
    },
    mounted:    function () {
      var that = this

      gmapsInit().then(function () {

        that.initMap()

        that.reload()
      })

    },
    filters:    {},
    computed:   {

      thumbPath ()
      {
        return CommonLib.getImageURL(this.target.object.thumbsPath[800])
      },
      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    methods:    {
      reload ()
      {
        var that = this

        var bounds = new google.maps.LatLngBounds()

        that.trip = that.activity.source.object
        // Rebuild one long segment with all previous smaller segments
        that.activity.source.object.route_segments.forEach(function (key, value) {

          var poly = new google.maps.Polyline({
            clickable: false,
            map:       that.map,
            path:      google.maps.geometry.encoding.decodePath(key)
          })

          poly.getPath().forEach(function (k, v) {
            bounds.extend(k)
          })
        })
        that.map.fitBounds(bounds)

      },
      initMap ()
      {
        // Regular Map
        const mapOptions = {
          zoom:                   6,
          center:                 new google.maps.LatLng(45.7, -73.90),
          mapTypeId:              google.maps.MapTypeId.TERRAIN,
          zoomControl:            false,
          mapTypeControl:         false,
          scaleControl:           false,
          panControl:             false,
          fullscreenControl:      false,
          navigationControl:      false,
          disableDoubleClickZoom: true,
          streetViewControl:      false,
          mapTypeControlOptions:  {
            style:      google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID,
              google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN]
          },
          scrollwheel:            true,
          draggableCursor:        'crosshair',
          animation:              google.maps.Animation.BOUNCE,
          gestureHandling:        'cooperative',
          styles:                 [{
            'featureType': 'poi.attraction',
            'stylers':     [{
              'visibility': 'off'
            }]
          },
            {
              'featureType': 'poi.business',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.medical',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.place_of_worship',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.school',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'transit.station.bus',
              'stylers':     [{
                'visibility': 'off'
              }]

            }
          ]
        }

        this.map = new google.maps.Map(this.$refs.myMap, mapOptions)
      },

    },
    watch:      {
      threadId ()
      {

        var that = this

      }

    }
  }

</script>

<style src="@/pages/Profile/Profile.scss" lang="scss" scoped/>

<style>
    .eventImage img {
        width: 100%;
        height: auto;

    }

</style>
